<div class="login-body">
    <div class="login-panel p-fluid">
        <div class="p-grid">
            <div class=" logo-container">
                <img [src]="assestBaseUrl + 'layout/images/lionO360_logo1.png'" alt="logo-dark" />
                <h1>Reset Password</h1>
            </div>
            <div class="p-col-12">
                <div style="text-align: center">Please provide the organization code & email address to reset password !</div> 
                <hr>               
            </div>
           
            <div class="p-col-12">
                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                    <div class="form-group p-mb-2">
                        <label for="orgId"><strong>Organization Code</strong><span style="color: red;"> *</span></label>
                        <input id="orgId" type="text" pInputText formControlName="organizationCode" 
                               maxlength="7" placeholder="Enter Organization Code"/>
                        <small *ngIf="submitted && f.organizationCode.errors" class="p-error">
                            <div *ngIf="f.organizationCode.errors.required">Organization Code is required</div>
                        </small>
                    </div>
                    <div class="form-group p-mb-2">
                        <label for="email"><strong>Email</strong><span style="color: red;"> *</span></label>
                        <input pInputText type="text" [ngStyle]="{'width': '100%'}" formControlName="email" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.email.errors }" placeholder="Enter your email" />
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                            <div *ngIf="f.email.errors.required">Email is required</div>
                        </div>
                    </div>
                   
                    <div class="form-group p-mb-2">
                        <p-button type="submit" [disabled]="!form.valid"  label="Submit" icon="pi pi-user"
                        styleClass="w-10rem mx-auto" [rounded]="true"  severity="info"  ></p-button>
                    </div>
                    <div class="form-group p-text-center p-mt-3">
                        <p-button 
                            label="Back to Login Page" 
                            icon="pi pi-arrow-left"  
                            [rounded]="true" 
                            severity="info" 
                            [link]="true"
                            [routerLink]="['/login']">
                        </p-button>
                    </div>
                    <!-- <div class="form-group p-text-center p-mt-4">
                        <a [routerLink]="['/login']" class="back-to-login"><i class="pi pi-arrow-left p-mr-2"></i> Back to Login Page</a>
                    </div> -->
                </form>
            </div>

        </div>
    </div>
</div>
<p-toast [baseZIndex]="999999"></p-toast>